import html from "./ProfilePhoto.html"
import "./ProfilePhoto.css"
import qq from "fine-uploader"

var module = angular.module("ResearchKitApplicationModule");
module.component('profilePhoto', {
	template: html,
	bindings: {
		"model": "<"
	},
	controllerAs: 'vm',
	controller: ["$element", "$rootScope", "$timeout", "ceUrl", function ($element, $rootScope, $timeout, ceUrl) {
		var vm = this;
		vm.updatedDate = new Date();

		vm.getParticipantImageUrl = function () {
			return ceUrl.make('api/profilephoto/patient/' + vm.model.PatientID + "?date=" + vm.updatedDate.getTime() + "&size=ProfileHeader");
		};

		$timeout(function () {
			if (!vm.model.IsSelf) return;

			new qq.FineUploaderBasic({
				button: $element.find(".upload-button")[0],
				text: {
					fileInputTitle: "Profile Photo"
				},
				request: {
					endpoint: ceUrl.make('api/profilephoto/'),
					customHeaders: {
						"X-XSRF-Token": $('[name=__RequestVerificationToken]').val()
					}
				},
				callbacks: {
					onUpload: function () {
						vm.loading = true;
						vm.error = false;
						$rootScope.$digest();
					},
					onComplete: function () {
						vm.loading = false;
						vm.updatedDate = new Date();
						$rootScope.$digest();
					},
					onError: function () {
						vm.loading = false;
						vm.error = true;
						$rootScope.$digest();
					}
				}
			});
		}, 0, false);
	}]
});
